module.exports = __webpack_public_path__ + "static/img/sprite2310.deeb66b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/sprite2310.png
// module id = kQdq
// module chunks = 7